export default "__VITE_PUBLIC_ASSET__8fac34be__"